import { LoyaltyMemberIdentifier } from '@vista-digital/occ-domain'
import { createContext } from 'react'

export interface LoginMethod {
    setLoginMethod: (method: LoyaltyMemberIdentifier) => void
    getLoginMethod: () => LoyaltyMemberIdentifier
}

export const LoginMethodContext = createContext<LoginMethod>({
    setLoginMethod: () => {},
    getLoginMethod: () => LoyaltyMemberIdentifier.Email,
})
